import { useState, useContext, useEffect } from 'react';
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import config from '../config';

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) return resolve();

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

function LoginPage() {
  const [form, setForm] = useState({ email: 'admin@example.com', password: 'admin123' });
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);
  // const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${config.API_BASE_URL}/api/master/auth/login`, form);
      const token = response.data.token;

      login(token);
      // navigate('/dashboard');
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
  };
  useEffect(() => {
    // Load phoenix.js and then initialize navbar toggle
    loadScript('/assets/js/phoenix.js')
      .then(() => {
        const waitAndInit = () => {
          if (
            window.phoenix &&
            window.phoenix.utils &&
            typeof window.handleNavbarVerticalCollapsed === 'function'
          ) {
            window.handleNavbarVerticalCollapsed();

            if (window.feather) {
              window.feather.replace();
            }
          } else {
            setTimeout(waitAndInit, 100);
          }
        };

        waitAndInit();
      })
      .catch((err) => {
        console.error("phoenix.js load failed", err);
      });
  }, []);

  return (
    <main className="main" id="top">
      <div className="row vh-100 g-0">
        <div className="col-lg-6 position-relative d-none d-lg-block">
          <div className="bg-holder" style={{ backgroundImage: "url(/assets/img/bg/30.png)" }}></div>
        </div>
        <div className="col-lg-6">
          <div className="row flex-center h-100 g-0 px-4 px-sm-0">
            <div className="col col-sm-6 col-lg-7 col-xl-6">
              <div className="d-flex align-items-center justify-content-center fw-bolder fs-3 d-inline-block"><img
                src="/assets/img/icons/logo.png" alt="phoenix" width="58" /></div>
              <div className="text-center mb-7">
                <h3 className="text-body-highlight">Sign In</h3>
                <p className="text-body-tertiary">Get access to your account</p>
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={handleSubmit}>

                <div className="mb-3 text-start"><label className="form-label" htmlFor="email">Email address</label>
                  <div className="form-icon-container"><input className="form-control form-icon-input" id="email" name="email" type="email" value={form.email} onChange={handleChange} required
                    placeholder="name@example.com" /><span className="fas fa-envelope text-body fs-9 form-icon"></span>
                  </div>
                </div>
                <div className="mb-3 text-start"><label className="form-label" htmlFor="password">Password</label>
                  <div className="form-icon-container" data-password="data-password">
                    <input
                      className="form-control form-icon-input pe-6" id="password" type="password" name="password" placeholder="Password"
                      data-password-input="data-password-input" value={form.password} onChange={handleChange} required />
                    <span
                      className="fas fa-key text-body fs-9 form-icon"></span>
                    <div
                      className="px-3 py-0 h-100 position-absolute top-0 end-0 fs-7 text-body-tertiary"
                      data-password-toggle="data-password-toggle">
                      <span className="uil uil-eye show"></span>
                      <span
                        className="uil uil-eye-slash hide"></span>
                    </div>
                  </div>
                </div>
                <div className="row flex-between-center mb-7">
                  <div className="col-auto">
                    <div className="form-check mb-0">
                      <input className="form-check-input" id="basic-checkbox" type="checkbox"
                        checked="checked" />
                      <label className="form-check-label mb-0" htmlFor="basic-checkbox">Remember
                        me</label>
                    </div>
                  </div>
                </div>
                <button className="btn btn-primary w-100 mb-3">Sign In</button>
              </form>
            </div>
          </div>

        </div>
      </div>
    </main>
  );
}

export default LoginPage;
